export default {"src":"/oferta/_next/static/media/home.e1ad057a.svg","height":40,"width":45,"blurWidth":0,"blurHeight":0};